import { FC, useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import { KTSVG } from "../../../smallnation/helpers";
import { Link } from 'react-router-dom';

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import { useLocation, useHistory } from 'react-router-dom';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import UsNumberValidate from "../../modules/utility/usNumberValidate";
//import ImageUploader from "react-images-upload";

const EditCompanyBasic: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [categories, setCategory] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [stateData, setStateData] = useState([]);
  //const [companyProf, setCompanyProfile] = useState([]);
  const [companyProf, setCompanyProfile] = useState<any>('');
  //const [companyinfo, setCompanyInfo] = useState([]);
  const [companyinfo, setCompanyInfo] = useState<any>('');
  const [companyDisplayName, setCompanyDisplayName] = useState([]);
  const red = "red";
  var companytitle_name;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyId = queryParams.get('companyId');
  const [userList, setUsersList] = useState([]);

  const [fileName, setFileName] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [fileBase64, setFileBase64] = useState('');
  var companylogofile = '';
  const [logourlDisplay, setLogoUrlDisplay] = useState('');
  var filename_logo = '';
  var fileext_logo = '';
  var filebase_logo = '';


  const [bannerName, setBannerName] = useState('');
  const [bannerExtension, setBannerExtension] = useState('');
  const [bannerBase64, setBannerBase64] = useState('');
  var companybannerfile = '';
  const [bannerurlDisplay, setBannerUrlDisplay] = useState('');
  var filename_banner = '';
  var fileext_banner = '';
  var filebase_banner = '';

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });


  function handleChangeCompanyProfileDesc(content) {
    setCompanyProfile(content);
  }


  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  function validateCheck() {
    const checked = $('input[name="procategory"]:checked').length;
    // alert(checked);
    if (checked >= 3) {
      $('input[name="procategory"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="procategory"]').prop('disabled', false);
    }
  }
  function getDisplayRole(rolev) {
    if (rolev == "employerUser") {
      return "Company User";
    } else if (rolev == "employerAdmin") {
      return "Company Admin";
    }
    return "";
  }

  function getDisplayStatus(st) {
    if (st == "active") {
      return "Active";
    } else if (st == "inactive") {
      return "Inactive";
    } else if (st == "pending") {
      return "Active";
    }
    return "";
  }

  function getCompanyInfo(companyId) {
    services.adminGetCompanyProfile(companyId).then((res) => {
      if (res.data) {
        setCompanyInfo(res.data);
        var companyProfile = res.data;
        /* {

                 "schoolId": null,
           "firstName": null,       "lastName": null,       "password": null,    "isStudent": null,
           "countyName": "ohio",   "email": "pipamycu@mailinator.com",  "bannerUrl": null,      "logoUrl": "",   "videoUrl": "",   "userType": null,   "hasAccessToJobPosting": "yes",
           "updatedOn": "2022-04-24T06:52:58.286+00:00",   "longitude": null,   "latitude": null,    "securityRoleId": null,   "securityRoleName": null,           "perksList": []
       } */
        var statustxt = "";
        if (companyProfile.status == "published" || companyProfile.status == "Published") {
          statustxt = "Published";
        }
        if (companyProfile.status == "pending" || companyProfile.status == "Pending") {
          statustxt = "Pending";
        }

        companylogofile = companyProfile.logoUrl;
        setLogoUrlDisplay(companyProfile.logoUrl);
        setBannerUrlDisplay(companyProfile.bannerUrl);
        setTimeout(() => {
          console.log("Delayed for 1 second.");
          $('#approval_status').val(statustxt);
          $('#first_name').val(companyProfile.firstName);
          $('#last_name').val(companyProfile.lastName);
          $('#public_profile').val(companyProfile.publicProfile);
          $('#view_resumes').val(companyProfile.hasAccessToResume);
          $('#company_name').val(companyProfile.name);
          var cst: any = "Edit Company - " + companyProfile.name;
          setCompanyDisplayName(cst);
          //setCompanyDisplayName("Edit Company - " + companyProfile.name)
          $('#email_id').val(companyProfile.email);
          $('#address_1').val(companyProfile.address1);
          $('#address_2').val(companyProfile.address2);
          $('#city').val(companyProfile.city);
          $('#state').val(companyProfile.state);
          $('#postalcode').val(companyProfile.zip);

          $('#country').val(companyProfile.countyId);
          $('#phone_number').val(companyProfile.phone);
          $('#noofemp').val(companyProfile.employeeCount);
          $('#websiteurl').val(companyProfile.webSite);
          $("#hasAccessToJobPosting").val(companyProfile.hasAccessToJobPosting);
          //$("#view_resumes").val(companyProfile.hasAccessToResume);
          $('#view_resumes option[value=' + companyProfile.hasAccessToResume + ']').attr('selected', 'selected');

          $('input[name="job_shadow"][value="' + companyProfile.jobShadowConcert + '"]').prop('checked', true);
          var catarray = companyProfile.companyCategory;
          console.log(catarray);
          for (var i = 0; i < catarray.length; i++) {
            //alert(catarray[i]);
            //$('#'+catarray[i]+'').prop('checked', true);
            // $('#'+catarray[i]+'').trigger("click");
            // $('input[name="procategory"][value="' + catarray[i] + '"]').trigger("click");
            $('input[name="procategory"][value="' + catarray[i] + '"]').prop('checked', true);
            $('input[name="procategory"][value="' + catarray[i] + '"]').attr('checked', "true");
          }
          for (var i = 0; i < catarray.length; i++) {
            $('#' + catarray[i]).prop('checked', true);
          }

          var newcatarray = catarray.filter(x => x !== null);
          console.log('******old array : ' + catarray);
          console.log('******new array : ' + newcatarray);

          if (newcatarray.length >= 3) {
            $('input[name="procategory"]').not(':checked').prop('disabled', true);
          } else {
            $('input[name="procategory"]').prop('disabled', false);
          }

        }, 1500)




      }

    });
  };

  const submitValue = () => {


    var categoriesArray = [];
    // var website_regex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    var website_regex = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    $.each($("input[name='procategory']:checked"), function () {
      categoriesArray.push($(this).val());
    });

    var validateEditorTxt = 1;

    var jobshadow_concert: any = "";

    $.each($("input[name='job_shadow']:checked"), function () {
      jobshadow_concert = $(this).val();
    });

    /*
    if(jobshadow_concert == ""){
      $("#jobshadow_concertValidMsg").show();
      $(window).scrollTop($('#jobshadow_concertValidMsg').position().top);
      validateEditorTxt = 0;
    }
*/

    if ($('#company_name').val() == '') {
      $("#companynameValidMsg").show();
      $(window).scrollTop($('#companynameValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#companynameValidMsg").hide();
    }

    if ($('#approval_status').val() == '') {
      $("#companystatusValidMsg").show();
      $(window).scrollTop($('#companystatusValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#companystatusValidMsg").hide();
    }

    if ($('#address_1').val() == '') {
      $("#addressValidMsg").show();
      $(window).scrollTop($('#addressValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#addressValidMsg").hide();
    }

    if ($('#city').val() == '') {
      $("#cityValidMsg").show();
      $(window).scrollTop($('#cityValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#cityValidMsg").hide();
    }

    if ($('#state').val() == '') {
      $("#stateValidMsg").show();
      $(window).scrollTop($('#stateValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#stateValidMsg").hide();
    }

    if ($('#postalcode').val() == '') {
      $("#postalcodeValidMsg").show();
      $(window).scrollTop($('#postalcodeValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#postalcodeValidMsg").hide();
    }

    if ($('#phone_number').val() == '') {
      $("#phoneValidMsg").show();
      $(window).scrollTop($('#phoneValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#phoneValidMsg").hide();
    }

    /*
        if ($('#country').val() == '') {
          $("#countryValidMsg").show();
          $(window).scrollTop($('#countryValidMsg').position().top);
          validateEditorTxt = 0;
        }
        else {
          $("#countryValidMsg").hide();
        } */
    var website: any = $('#websiteurl').val();
    var regexvalid = website_regex.test(website);
    if (website != "" && regexvalid == false) {
      $("#howtoapplyValidregex").show();
      $(window).scrollTop($('#howtoapplyValidregex').position().top);
      validateEditorTxt = 0;
    } else {
      $("#howtoapplyValidregex").hide();
    }

    if ($('#noofemp').val() == '') {
      $("#employeesValidMsg").show();
      $(window).scrollTop($('#employeesValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#employeesValidMsg").hide();
    }

    if (categoriesArray.length == 0) {
      $("#categoryValidMsg").show();
      $(window).scrollTop($('#categoryValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#categoryValidMsg").hide();
    }
    if (companyProf == "") {
      $("#companyProfileValidMsg").show();
      $(window).scrollTop($('#companyProfileValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#companyProfileValidMsg").hide();
    }
    if (validateEditorTxt == 0) {
      return false;
    }



    //console.log(categoriesArray);
    const categoryData = JSON.stringify(categoriesArray);
    console.log(categoryData);

    const str: any = $("#phone_number").val();
    const contactNumber = str.replace(/[^a-zA-Z0-9]/g, "")
    //const siteId =Math.floor(Math.random() * 10);.
    const siteId = "2";
    var accessTokenTov = sessionStorage.getItem("adminAccToken");
    const requestObject: any =
    {
      "companyId": companyId,
      // "siteId" :"2",
      // "firstName" : $("#first_name").val(),
      // "lastName" : $("#last_name").val(),
      // "email" : $("#email_id").val(),

      "password": $("#password").val(),
      "isStudent": "No",

      "status": $("#approval_status").val(),
      "publicProfile": $("#public_profile").val(),
      "hasAccessToResume": $("#view_resumes").val(),
      "hasAccessToJobPosting": $("#hasAccessToJobPosting").val(),

      "name": $("#company_name").val(),
      "address1": $("#address_1").val(),
      "address2": $("#address_2").val(),
      "city": $("#city").val(),
      "state": $("#state").val(),
      "zip": $("#postalcode").val(),
      "countyId": $("#country").val(),
      "phone": $("#phone_number").val(),
      "employeeCount": $("#noofemp").val(),
      "webSite": $("#websiteurl").val(),
      "companyCategory": categoriesArray,
      "description": companyProf
      //"jobShadowConcert" : jobshadow_concert

      //"logourl":"",
      //"videourl":"",


    }

    if (jobshadow_concert != "") {
      requestObject.jobShadowConcert = jobshadow_concert;
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.adminEditCompanyProfile(requestOptions).then((res) => {

      if (res.code == '200') {
        $("#editcompanybasicssuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editcompanybasicssuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/companydirectory');
        }, 1000);
      }
      else {
        $("#editcompanybasicsfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editcompanybasicsfailMessage").slideUp(500);
        });
        setTimeout(() => {
        }, 1000);
      }

    });
  }

  function filterUserList(companyId) {

    const requestObject = {

      "siteId": "2",
      "userType": "company",
      "searchTxt": "",
      "companyId": companyId,
      "pageNumber": 1,
      "pageSize": 150
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         'Authorization': "Bearer "+accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.getAdminUserList(requestOptions).then((res) => {
      console.log("#######################");
      console.log(res);
      if (res) {
        // console.log(JSON.stringify(res));
        try {
          setUsersList(res.content);
        } catch (ex) {
          console.log("ex:" + ex);
        }

      }
      else {
        setUsersList([]);
      }


    });
  }

  function getImage() {
    //var files = document.getElementById('company_logo_new').files;
    var files: any = (document.getElementById("company_logo_new") as HTMLInputElement | null)?.files;
    if (files.length > 0) {
      console.log(files);
      var sizeInBytes = files[0].size;
      var sizeInMB = (sizeInBytes / (1024*1024)).toFixed(2);
      console.log(sizeInBytes+' - '+sizeInMB);
//return false;
      if(sizeInMB > "1"){
         $("#imageSizeError").show();
         return false;
     }
     else {
         $("#imageSizeError").hide();
      var fname = files[0].name;
      // var fextn = fname.substr(0, fname.lastIndexOf('.'));
      var fextn = fname.split(".").pop();
      // alert(fextn);
      var fileActName = fname.split(".")[0];

      setFileName(fileActName);
      filename_logo = fileActName;
      setFileExtension(fextn);
      fileext_logo = fextn;
      getBase64(files[0]);
      //alert(fileActName);
      if (fextn != "png" && fextn != "jpeg" && fextn != "jpg" && fextn != "gif") {

        $("#fileError").show();
        return false;
      } else {
        $("#fileError").hide();
        setTimeout(() => {
          updateCompanyLogo();
        }, 1000)

      }
    }
    }
  }
  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      var rdt: any = reader.result;
      var base64result = rdt.split(',')[1];
      //var base64result = reader.result.split(',')[1];
      filebase_logo = base64result;
      setFileBase64(base64result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  function updateCompanyLogo() {
    //alert(filename_logo);
    //alert(fileext_logo);
    //alert(filebase_logo);
    const requestObject = {
      "logoName": filename_logo,
      "companyId": companyId,
      "logoExtension": fileext_logo,
      "logoByteString": filebase_logo
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.admineditCompanyLogo(requestOptions).then((res) => {
      console.log(res);
      getCompanyInfo(companyId);
    });
  }

  function getBannerImage() {
    //var banner = document.getElementById('company_banner_new').files;
    var banner: any = (document.getElementById("company_banner_new") as HTMLInputElement | null)?.files;
    if (banner.length > 0) {

var sizeInBytes = banner[0].size;
var sizeInMB = (sizeInBytes / (1024*1024)).toFixed(2);
console.log(sizeInBytes+' - '+sizeInMB);

      var bname = banner[0].name;
      var bextn = bname.split(".").pop();
      // alert(fextn);
      var bannerActName = bname.split(".")[0];

      setBannerName(bannerActName);
      filename_banner = bannerActName;
      setBannerExtension(bextn);
      fileext_banner = bextn;
      getBase64_banner(banner[0]);

      
      if(sizeInMB > "3") {
        $("#bannerSizeError").show();
        return false;
      }
      else{
        $("#bannerSizeError").hide();
          //alert(fileActName);
          if (bextn != "png" && bextn != "jpeg" && bextn != "jpg" && bextn != "gif") {

            $("#bannerError").show();
            return false;
          } else {
            $("#bannerError").hide();
            setTimeout(() => {
              updateCompanyBanner();
            }, 1000)

          }
      }
    }
  }

  function getBase64_banner(file) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(file);
    reader1.onload = function () {
      // console.log(reader.result);
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      //var base64result_banner = reader1.result.split(',')[1];
      filebase_banner = base64result_banner;
      setBannerBase64(base64result_banner)
    };
    reader1.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  function updateCompanyBanner() {
    //alert(filename_banner);
    //alert(fileext_banner);
    //alert(filebase_banner);
    const requestObject = {
      "imageName": filename_banner,
      "companyId": companyId,
      "imageExtension": fileext_banner,
      "imageByteString": filebase_banner
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.admineditCompanyBanner(requestOptions).then((res) => {
      console.log(res);
      getCompanyInfo(companyId);
    });
  }

  useEffect(() => {

    validateCheck();
    getCompanyInfo(companyId);
    filterUserList(companyId);
    $(".se-dialog-tabs").hide();
    $("#jobshadow_concertValidMsg").hide();
    //$('#phone_number').usPhoneFormat();
    ($('#phone_number') as any).usPhoneFormat();
    $("#companyProfileValidMsg").hide();
    $("#companynameValidMsg").hide();
    $("#companystatusValidMsg").hide();
    $("#addressValidMsg").hide();
    $("#cityValidMsg").hide();
    $("#stateValidMsg").hide();
    $("#postalcodeValidMsg").hide();
    $("#howtoapplyValidregex").hide();
    $("#countryValidMsg").hide();
    $("#employeesValidMsg").hide();
    $("#fileError").hide();
    $("#bannerError").hide();
    $("#bannerSizeError").hide();
    $('#imageSizeError').hide();
    $("#categoryValidMsg").hide();
    $("#editcompanybasicssuccessMessage").hide();
    $("#editcompanybasicsfailMessage").hide();
    $('#phoneValidMsg').hide();
    services.getIndustryData().then((res) => {
      //console.log("count"+res);
      setCategory(res.data.content);
    })
    services.getLocationCounty().then((res) => {
      //console.log("getLocationCounty data=" + JSON.stringify(res.data));
      setLocationCounty(res.data.content);
    });
    var statesJson = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);
  }, []);

  return (
    <>
      <PageTitle breadcrumbs={[]}>{companyDisplayName}</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container px-0">
          <div className="row">
            <h3 className="mb-7">Basic Edits</h3>
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Company Name</label>

                </div>
                <input type="text" id="company_name" name="company_name" className="form-control" defaultValue="Company Name" placeholder="" />
                <div id="companynameValidMsg" style={{ color: red }} className="error">Company Name is required.</div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">

                <div className="d-flex flex-column ">
                  <label className=" required form-label">Status</label>
                  <small className="mb-3">Overall Approval Status</small>
                </div>
                <select id="approval_status" name="approval_status" className="form-select" aria-label="Select example" >
                  <option value="">Select Status</option>
                  <option value="Published">Published</option>
                  <option value="Pending">Pending</option>
                </select>
                <div id="companystatusValidMsg" style={{ color: red }} className="error">Approval Status is required.</div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="mb-10" style={{ position: "relative" }}>

                <a href="#">

                  <div style={{ width: "30px", height: "30px", position: "absolute", top: "40px", right: "5px", background: "white", borderRadius: "15px", textAlign: "center", lineHeight: "30px" }}>
                    <input className="form-control form-control-lg browse mr-2 brow-hide" id="company_logo_new" type="file" onChange={() => getImage()} />
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3 ic-pos-edit' />
                  </div>
                </a>

                <div className="d-flex flex-column ">
                  <label className="  form-label">Company Logo : {logourlDisplay ? <img src={logourlDisplay} alt='' className="w-100 mt-4 admin-logo-edit" /> : <b>Logo Not Available</b>}</label>

                  {logourlDisplay ? '' :
                    <div className="df-admin-image-bg mt-2">
                      <img src="/media/no-image.svg" alt="" />
                    </div>
                  }
                  <div id="fileError" style={{ color: red }} className="error">Invalid File Format.</div>
                  <div id="imageSizeError" style={{ color: red }} className="error">Image size is greater than 1 MB. Please upload Image below 1MB.</div>
                  <div className="d-flex flex-column mt-2">
                    <small>- Maximum upload file size: <b>1MB</b></small>
                  </div>
                </div>


              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10" style={{ position: "relative" }}>

                <a href="#">

                  <div style={{ width: "30px", height: "30px", position: "absolute", top: "40px", right: "5px", background: "white", borderRadius: "15px", textAlign: "center", lineHeight: "30px" }}>
                    <input className="form-control form-control-lg browse mr-2 brow-hide" id="company_banner_new" type="file" onChange={() => getBannerImage()} />
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3 ic-pos-edit' />
                  </div>
                </a>

                <div className="d-flex flex-column ">
                  <label className="  form-label">Company Banner : {bannerurlDisplay ? <img src={bannerurlDisplay} alt='' className="w-100 mt-4" /> : <b>Banner Not Available</b>}</label>
                  {bannerurlDisplay ? '' :
                    <div className="df-admin-image-bg mt-2">
                      <img src="/media/no-image.svg" alt="" />
                    </div>
                  }

                  <div id="bannerError" style={{ color: red }} className="error">Invalid File Format.</div>
                  <div id="bannerSizeError" style={{ color: red }} className="error">Image size is greater than 3 MB. Please upload Image below 3MB.</div>
                  <div className="d-flex flex-column mt-2">
                    <small>- Suggested Image dimensions <b>1300X365</b> pixels</small>
                    <small>- Maximum upload file size: <b>3MB</b></small>
                  </div>
                </div>

              </div>
            </div>






            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Public Profile?</label>

                </div>
                <select id="public_profile" name="public_profile" className="form-select" aria-label="Select example">
                  <option value="yes">Yes</option>
                  <option value="no">No</option>

                </select>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="form-label">View Resumes?</label>

                </div>
                <select id="view_resumes" name="view_resumes" className="form-select" aria-label="Select example">
                  <option value="yes">Yes</option>
                  <option value="no">No</option>

                </select>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="hasAccessToJobPosting" className="form-label">Has access to Job Posting?</label>

                </div>
                <select id="hasAccessToJobPosting" name="hasAccessToJobPosting" className="form-select" aria-label="Select example">
                  <option value="yes">Yes</option>
                  <option value="no">No</option>

                </select>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">

              </div>
            </div>

            {/* <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">First Name</label>

                </div>
                <input type="text" id="first_name" name="first_name" className="form-control" defaultValue="First Name" placeholder="" {...register("first_name", {
                  required: "Address is required."

                })} />

                <ErrorMessage
                  errors={errors}
                  name="first_name"
                  className="invalid-feedback"
                  render={({ messages }) => {
                    console.log("messages", messages);
                    return messages
                      ? Object.entries(messages).map(([type, message]) => (
                        <p style={{ color: red }} className="error">{message}</p>
                      ))
                      : null;
                  }}
                />
              </div>
            </div> */}


            {/* <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Last Name</label>

                </div>
                <input type="text" id="last_name" name="last_name" className="form-control" defaultValue="Last Name" placeholder="" {...register("last_name", {
                  required: "Address is required."

                })} />

                <ErrorMessage
                  errors={errors}
                  name="last_name"
                  className="invalid-feedback"
                  render={({ messages }) => {
                    console.log("messages", messages);
                    return messages
                      ? Object.entries(messages).map(([type, message]) => (
                        <p style={{ color: red }} className="error">{message}</p>
                      ))
                      : null;
                  }}
                />
              </div>
            </div> */}

            {/* <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="  form-label">Email</label>

                </div>
                <input type="text" id="email_id" name="email_id" className="form-control" defaultValue="Last Name" placeholder="" disabled="true" />


              </div>
            </div> */}


            <div className="col-lg-12">
              <div className="mb-10">
              </div></div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">Address</label>

                </div>
                <input type="text" id="address_1" name="address_1" className="form-control" defaultValue="Address 1" placeholder="" />
                <div id="addressValidMsg" style={{ color: red }} className="error">Address is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="  form-label">Address 2</label>

                </div>
                <input type="text" id="address_2" name="address_2" className="form-control" placeholder="" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">City</label>

                </div>
                <input type="text" id="city" name="city" className="form-control" />
                <div id="cityValidMsg" style={{ color: red }} className="error">City is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" required form-label">State</label>

                </div>
                <select id="state" name="state" className="form-select" aria-label="Select example" >
                  <option value="" >Select State</option>
                  {
                    stateData.map((state, index) => (
                      <option value={state.stateCode}>{state.stateName}</option>
                    ))
                  }
                </select>
                <div id="stateValidMsg" style={{ color: red }} className="error">State is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Zipcode</label>

                </div>
                <input type="text" id="postalcode" name="postalcode" className="form-control" placeholder="" />
                <div id="postalcodeValidMsg" style={{ color: red }} className="error">Zipcode is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="  form-label">County</label>

                </div>
                <select id="country" name="country" className="form-select" aria-label="Select example" >

                  <option value="" >Select County</option>
                  {
                    locationCounty.map((data, index) => (
                      <option value={data.jobLocationCountyId} >{data.name}</option>
                    ))}
                </select>
                <div id="countryValidMsg" style={{ color: red }} className="error">County is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Phone</label>
                  {/* <small className="mb-3">xxx-xxx-xxxx </small> */}
                </div>
                <input type="text" id="phone_number" name="phone_number" className="form-control" placeholder="" />
                <div id="phoneValidMsg" style={{ color: red }} className="error">Phone is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" defaultValue="1" className="required form-label">No of Employees</label>

                </div>
                <input type="text" id="noofemp" name="noofemp" className="form-control" placeholder="" />
                <div id="employeesValidMsg" style={{ color: red }} className="error">No of Employees is required.</div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Website</label>
                  <small>Example: http://example.com</small>

                </div>
                <input type="text" id="websiteurl" name="websiteurl" className="form-control" placeholder="" />
                <div id="howtoapplyValidregex" style={{ color: red }} className="error">Please enter valid website URL.</div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Company Profile</label>
                </div>
                {/*} <h1>this is FCK editor area</h1>*/}
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="companyProfileId"
                  data={companyinfo.description}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setCompanyProfile(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeCompanyProfileDesc}
                  setContents={companyinfo.description}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />

                <div id="companyProfileValidMsg" className="error">Company Profile is required.</div>
                {/*<textarea id="careers" cols="30" rows="10"  style={{maxHeight: 75, minWidth: '100%'}} {...register("companyprofile", {
                          required: "This field is required",
                          maxLength: { value: 2000, message: 'Should not allow more than 2000 character' }
                        })}></textarea>
                        	<ErrorMessage
                          errors={errors}
                          name="companyprofile"
                          className="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} className="error">{message}</p>
                              ))
                              : null;
                          }}

                        />*/}
              </div>
            </div>




            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Company Industry</label>
                  <small>Max 3 Categories</small>
                  <div className="row mt-2">

                    <div className="row">
                      {
                        categories.map((category, index) => (
                          <div className=" col-md-6 form-check form-check-custom form-check-solid py-2"><input className="form-check-input" type="checkbox" value={category.catId} name="procategory" id={category.catId} onClick={() => validateCheck()} />  <label className="form-check-label" htmlFor="defaultCheck1"> {category.name} </label></div>
                        ))
                      }

                      {/* {...register('category', { required: true })} */}

                    </div>
                    <div id="categoryValidMsg" style={{ color: red }} className="error">Please Check at least 1 category.</div>
                    {/* {errors.category && errors.category.type === "required" && <div style={{color:red}} className="error">Please check atleast One category</div>} */}



                  </div>
                </div>

              </div>
            </div>


            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Does your company provide Job Shadow opportunities?</label>
                </div>


                <input className="form-check-input" type="radio" value="Y" name="job_shadow" id="job_shadow_y" />  <label className="form-check-label" htmlFor="defaultCheck1"> Yes </label> &nbsp; &nbsp;
                <input className="form-check-input" type="radio" value="N" name="job_shadow" id="job_shadow_n" />  <label className="form-check-label" htmlFor="defaultCheck1"> No </label>


                <div id="jobshadow_concertValidMsg" style={{ color: red }} className="error">This field is required.</div>




                <div className="divider"></div>

                <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}> Update Company </button>
                <div>
                  <span id="responseTxt"></span>
                </div>

                <div id="editcompanybasicssuccessMessage" className="alert alert-success" role="alert">Company Edited Successfully</div>
                <div id="editcompanybasicsfailMessage" className="alert alert-danger" role="alert">Please try again</div>





              </div>
            </div>






          </div>




        </div>
      </form>
    </>
  )
}
export { EditCompanyBasic }